import React, { useState } from 'react';
import { BodyProps, CategoryAccordionProps } from '../../types';
import {
  AbsenceYearlySummaryDocument,
  useAbsenceYearlySummaryQuery,
} from '../../../../__generated__/graphql';
import ServerError from '../../../../../../components/ServerError';
import Body from './Body';
import { mapSummary } from './mappings';
import Loading from '../Loading';
import { PeriodType } from './types';
import { useEmployeeIdContext } from '../../../../context/EmployeeIdContext';

type Props = Pick<
  CategoryAccordionProps,
  | 'category'
  | 'hideRequestButton'
  | 'categories'
  | 'isActive'
  | 'refetchQueries'
>;

export const BodyConnected: React.FC<React.PropsWithChildren<Props>> = ({
  category,
  isActive = false,
  refetchQueries: additionalRefetchQueries,
  ...props
}) => {
  const { employeeId } = useEmployeeIdContext();

  const { data, error, loading } = useAbsenceYearlySummaryQuery({
    variables: { employeeId },
    skip: !isActive,
  });

  const refetchQueries = [
    {
      query: AbsenceYearlySummaryDocument,
      variables: { employeeId },
    },
    ...(additionalRefetchQueries || []),
  ];

  const employee = data?.employee;
  const absenceCategory = employee?.absenceCategories.find(
    (c) => c.Id === category.Id,
  );

  const summary = absenceCategory ? mapSummary(absenceCategory) : null;
  const [periodType, setPeriodType] = useState<PeriodType>('current');

  if (error) {
    return <ServerError />;
  }
  if (loading) {
    return <Loading />;
  }
  if (!summary) {
    return null;
  }

  const bodyProps: BodyProps = {
    summary,
    onPeriodChanged: setPeriodType,
    periodType,
    category,
    loading,
    refetchQueries,
    ...props,
  };

  return <Body {...bodyProps} />;
};
